import { render, staticRenderFns } from "./add_order.vue?vue&type=template&id=7b54b080&scoped=true&"
import script from "./add_order.vue?vue&type=script&lang=js&"
export * from "./add_order.vue?vue&type=script&lang=js&"
import style0 from "./add_order.vue?vue&type=style&index=0&id=7b54b080&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b54b080",
  null
  
)

export default component.exports